// extracted by mini-css-extract-plugin
export var cardContainer = "_p9-0";
export var cardHeader = "_p9-2";
export var collapsedState = "_p9-3";
export var dragHandle = "_p9-5";
export var dragHandleIcon = "_p9-6";
export var dragging = "_p9-1";
export var titleArea = "_p9-4";